export default "__VITE_ASSET__21cde94d__"